import React from 'react';
import {size, isEmpty, sortBy, values, startCase, flatten} from 'lodash';
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";
import AddToCartWithQuantity from "./AddToCartWithQuantity";
import clsx from "clsx";
import ToolProductInfo from "./ToolProductInfo";
import ToolPriceDisplay from "../ClusteredItems/main/ToolPriceDisplay";

/**
 * This is used on the non-clustered group page.
 * Invoked from UniversalItemList.
 *
 * @param product
 * @param products
 * @param className
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function AddToolProduct({
  product, products = {},
  className, ...props
}) {
  if (!product)
    return null;

  // product may be null, in that case show a greyed-out button
  product = camelizeKeysDeep(product);

  const hasNeighbours = size(products) > 1;
  className = clsx(className, "my-4",
    hasNeighbours ? "border-b border-gray-200 pb-4 " : "");

  return (
    <div className={className}>
      <div className="py-2 grid grid-cols-4">
        <div className="col-span-3">
          <ToolProductInfo product={product}/>
        </div>
        <ToolPriceDisplay product={product}/>
      </div>

      <AddToCartWithQuantity product={product} {...props} />
    </div>
  );
}
